<div *ngIf="(flashAlert | json) != '{}'" class="{{ cssClass(flashAlert) }} alert-dismissable">
    {{flashAlert.message}}
    <a class="close" (click)="removeAlert()">&times;</a>
  </div>